module.exports = __webpack_public_path__ + "static/img/12.31218e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting824/images/12.png
// module id = +MNN
// module chunks = 4